import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

const TextFilter = ({ inputValue, handleInputChange, handleInputKeyPress, handleSearchClick }) => {
    const handleIconKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleSearchClick();
        }
    };

    return (
        <div className="filter-item">
            <label htmlFor="text-filter">Text Filter:</label>
            <div style={{ position: 'relative', display: 'inline-block' }}>
                <input
                    className="filter-input"
                    type="text"
                    id="text-filter"
                    placeholder="Search..."
                    value={inputValue}
                    onChange={handleInputChange}
                    onKeyPress={handleInputKeyPress}
                    autoComplete="off"
                    autoCorrect="off"
                    spellCheck="false"
                    aria-label="Text search filter"
                    aria-describedby="text-filter-description"
                />
                <span
                    className="filter-icon"
                    onClick={handleSearchClick}
                    onKeyDown={handleIconKeyDown}
                    role="button"
                    tabIndex={0}
                    aria-label="Search"
                >
                    <FontAwesomeIcon
                        icon={faMagnifyingGlass}
                        aria-hidden="true"
                    />
                </span>
                <span id="text-filter-description" className="sr-only">
                    Press Enter to search or click the search icon
                </span>
            </div>
        </div>
    );
};

TextFilter.propTypes = {
    inputValue: PropTypes.string.isRequired,
    handleInputChange: PropTypes.func.isRequired,
    handleInputKeyPress: PropTypes.func.isRequired,
    handleSearchClick: PropTypes.func.isRequired,
};

export default TextFilter;
